export default class FileManager {
    deviceready() {
        return new Promise(function (resolve, reject) {
            document.addEventListener("deviceready", resolve, false);
            setTimeout(function () { reject(new Error('deviceready has not fired after 5 seconds.')); }, 5100);
        });
    };
    writeFile(fileName, data) {
        return new Promise(function (resolve, reject) {
            if (typeof cordova === 'undefined' || typeof cordova.file === 'undefined') {
                reject('cordova.file not ready, cannot save to local file');
                return;
            }
            var folder = cordova.file.dataDirectory;
            //deviceready-------- no fired yet
            if (!folder) {
                reject('cordova.file.dataDirectory not found, cannot save to local file.');
                return;
            }
            window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (directoryEntry) {
                directoryEntry.getFile(fileName, { create: true }, function (fileEntry) {
                    fileEntry.createWriter(function (fileWriter) {
                        fileWriter.onwriteend = function (e) {
                            // for real-world usage, you might consider passing a success callback
                             resolve('Write file "' + fileName + '" completed.');
                        };

                        fileWriter.onerror = function (e) {
                            // you could hook this up with our global error handler, or pass in an error callback
                            reject('Write failed: ' + e.toString());
                        };

                        var blob = new Blob([data], { type: 'text/plain' });
                        fileWriter.write(blob);
                    }, function (e) { reject(e) });
                }, function (e) { reject(e) });
            }, function (e) { reject(e) });
        });
    };

    errorHandler(filename) {
    };

    readFile(fileName) {
        return new Promise(function (resolve, reject) {
            if (typeof cordova === 'undefined') {
                reject('cordova not found');
                return;
            }
            this.deviceready().then(function () {
                if (typeof cordova.file === 'undefined') {
                    reject('cordova.file plugin not found');
                    return;
                }
                var folder = cordova.file.dataDirectory;
                //deviceready-------- no fired yet
                if (!folder) {
                    reject('cordova.file.dataDirectory not found, cannot save to local file.');
                    return;
                }
                window.resolveLocalFileSystemURL(cordova.file.dataDirectory, function (directoryEntry) {
                    directoryEntry.getFile(fileName, { create: true }, function (fileEntry) {
                        fileEntry.file(function (file) {
                            var reader = new FileReader();

                            reader.onloadend = function (e) {
                                console.log("FileManager: Successful file read: " + this.result + ": " + fileEntry.fullPath);
                                resolve(this.result);
                            };

                            reader.readAsText(file);

                        }, function (e) { reject(e) });
                    }, function (e) { reject(e) });
                }, function (e) { reject(e) });
            });
        }.bind(this));
    };

}
